import IndicatorManagement from "./IndicatorManagement";
import { OPEN } from "../../../ducks/loadingSpinner";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { clearMessages } from "../../../ducks/message";
import { LANGUAGE } from "../../../ducks/languageSelector";
import {
  ACTION_FIELDS,
  createActionField,
  createIndicator,
  createResult,
  deleteActionField,
  deleteIndicator,
  deleteResult,
  editActionField,
  EDITED_ACTION_FIELD,
  EDITED_INDICATOR,
  EDITED_RESULT,
  editIndicator,
  editResult,
  INDICATOR_CODE_VALID,
  INDICATORS,
  LIBRARY_QUESTIONS,
  loadActionFields,
  loadLibraryQuestions,
  QUESTIONS,
  resetState,
  RESULTS,
  saveActionField,
  saveIndicator,
  saveResult,
  SELECTED_ACTION_FIELD,
  SELECTED_RESULT,
  selectedActionFieldChange,
  selectedResultChange
} from "../../../ducks/indicatorManagament";
import { INDICATOR_MANAGEMENT_STORE, LANGUAGE_SELECTOR } from "../../../common/constant";

const mapStateToProps = (state) => {
  return {
    actionFields: state[INDICATOR_MANAGEMENT_STORE][ACTION_FIELDS],
    results: state[INDICATOR_MANAGEMENT_STORE][RESULTS],
    indicators: state[INDICATOR_MANAGEMENT_STORE][INDICATORS],
    questions: state[INDICATOR_MANAGEMENT_STORE][QUESTIONS],
    libraryQuestions: state[INDICATOR_MANAGEMENT_STORE][LIBRARY_QUESTIONS],

    selectedActionField: state[INDICATOR_MANAGEMENT_STORE][SELECTED_ACTION_FIELD],
    selectedResult: state[INDICATOR_MANAGEMENT_STORE][SELECTED_RESULT],

    editedActionField: state[INDICATOR_MANAGEMENT_STORE][EDITED_ACTION_FIELD],
    editedResult: state[INDICATOR_MANAGEMENT_STORE][EDITED_RESULT],
    editedIndicator: state[INDICATOR_MANAGEMENT_STORE][EDITED_INDICATOR],

    indicatorCodeValid: state[INDICATOR_MANAGEMENT_STORE][INDICATOR_CODE_VALID],

    locale: state[LANGUAGE_SELECTOR][LANGUAGE],

    loading: state.loading[OPEN]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadActionFields,
      loadLibraryQuestions,

      saveActionField,
      saveResult,
      saveIndicator,

      selectedActionFieldChange,
      selectedResultChange,

      createActionField,
      createResult,
      createIndicator,

      editActionField,
      editResult,
      editIndicator,

      deleteActionField,
      deleteResult,
      deleteIndicator,

      clearMessages,

      resetState
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorManagement);
